/**
 * Created by Parisa on 12/28/2020.
 */
import {Injectable} from '@angular/core';

@Injectable()
export class AppConfig {
  // Base Url
  public baseUrl = 'https://api.mypomodoro.ir/';
  // Dev Base Url
  // public baseUrl = 'https://devapi.mypomodoro.ir/';
}
